module.exports = __webpack_public_path__ + "media/images/niq-filter-384f89f1c11a71cce796fc0a28ff5299.svg";